import React from 'react';
import Text from './base';

const Body = props => <Text tag="p" variant="body" {...props} />;

export default Body;
